
 import React, { useContext } from "react";
// import { StateContext } from '../components/context/ManageStates';
import { notify } from '../../components/common';
import Apis from "../../services/Apis";
import useRazorpay from "react-razorpay";
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from 'react-redux';
import OrderAction from "./OrderAction";
const MyAccountAction = () => {
    const dispatch = useDispatch()
    const [Razorpay] = useRazorpay();
    const { updateCheckout } = OrderAction();
    const { getUserProfile, updateCustomerProfile, sendotpService, verifyotpService,getSubscription,saveSubscription } = Apis();

    // const { setprofileData, setLoaderstatus, setotpform, otpform, setotpToken, setopenModal, otpToken, setupdatedProfilephone,updatedProfilephone } = useContext(StateContext);
    const otpform = useSelector(state => state.masterdata.otpform);
    const razzer = useSelector(state => state.orderdetail.razzer);
    const otpToken = useSelector(state => state.masterdata.otpToken);
    const authStatus = useSelector(state => state.masterdata.authStatus);
    const updatedProfilephone = useSelector(state => state.masterdata.updatedProfilephone);
    const navigate = useNavigate();
    const rstatus = razzer && razzer.length > 0 && razzer[0] && razzer[0].rstatus ? razzer[0].rstatus : null;
    const payment_method_key = razzer && razzer.length > 0 && razzer[0] && razzer[0].payment_method ? razzer[0].payment_method : null;

    const updateProfile = async (input_data, errors) => {
        dispatch({
            type: 'setLoaderstatus', payload: true
        })
        const response = await updateCustomerProfile(input_data);
        if (response.data.status == "success") {
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
            navigator.vibrate(300);
            notify('add2cart', response.data.message, false)
            getProfileData()
            navigate('/my-account')
        } else {
            if (response.data.message == 'Old password is wrong') {
                errors["old_password"] = response.data.message;
            }
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
            navigator.vibrate(300);
            notify('warning', response.data.message, false)
        }
    };
    const getProfileData = async (id) => {
        dispatch({
            type: 'setLoaderstatus', payload:true
        })
        const response = await getUserProfile();
        if (response.data.status == "success") {
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
            
            dispatch({
                type: 'setprofileData', payload: response.data.data
            })
        }
        if (response.status == 200) {
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
        }
    };
    const sendotp = async (input_data, errors) => {
        dispatch({
            type: 'setLoaderstatus', payload: true
        })
        if (otpform == 0) {
            const response = await sendotpService(input_data);
            if (response.data.status == "success") {
                if (input_data.hasOwnProperty("email")) {
                    dispatch({
                        type: 'setLoaderstatus', payload: false
                    })
                
                    dispatch({
                        type: 'setotpform', payload: 1
                    })
                } else {
                
                    dispatch({
                        type: 'setotpToken', payload: response.data.data.split('":\"')[2].split('"\}')[0]
                    })
                    dispatch({
                        type: 'setLoaderstatus', payload: false
                    })
        
                    dispatch({
                        type: 'setotpform', payload: 1
                    })
                }

            } else {
                errors["email"] = response.data.message;
            }
            if (response.status == 200) {
                dispatch({
                    type: 'setLoaderstatus', payload: false
                })
            }
        } else {
            input_data.token = otpToken;
            const secondresponse = await verifyotpService(input_data);
            if (secondresponse.status == "200") {
                if (input_data.hasOwnProperty("email")) {
                    if (secondresponse.data.status == "success") {
                    
                        dispatch({
                            type: 'setLoaderstatus', payload: false
                        })
                    
                        dispatch({
                            type: 'setotpform', payload:0
                        })
                    
                        dispatch({
                            type: 'setopenModal', payload:false
                        })
                        dispatch({
                            type: 'setupdatedProfilephone', payload:{
                                ...updatedProfilephone,
                                mailid: input_data.email
                            }
                        })
                      
                    }else{
                        
                        dispatch({
                            type: 'setLoaderstatus', payload: false
                        })
                        errors["otp"] = secondresponse.data.message;
                    }
                } else {
                    var op = secondresponse.data.message.split('":\"')[2].split('"\}')[0];
                    if (op == 'OTP Mismatch') {
                        errors["otp"] = op;
                    }
                    if (op == 'OTP Matched') {
                        dispatch({
                            type: 'setupdatedProfilephone', payload:{
                                ...updatedProfilephone,
                                phone: input_data.mobile
                            }
                        })
                       
                        dispatch({
                            type: 'setopenModal', payload:false
                        })
                        dispatch({
                            type: 'setotpToken', payload: ""
                        })
                    }
        
                dispatch({
                    type: 'setLoaderstatus', payload:false
                })

                }
                
                // setotpform(1)
            }
        }

    };
    const getSubscriptionlist = () => async dispatch => {
        dispatch({
            type: 'setLoaderstatus', payload: true
        })
        if (!authStatus) {
          var input_data = {
            "session_id": localStorage.getItem("sessionId") == null ? "0" : localStorage.getItem("sessionId")
          }
        }
        const response = await getSubscription(input_data);
        if (response.data.status == "success") {
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
            dispatch({
                type: 'setSubscription', payload: response.data.data
            })
        //   setSubscription(response.data.data);
        }
        if (response.status == 200) {
            dispatch({
                type: 'setLoaderstatus', payload: false
            })
    
        }
      };


      const saveSubscriptionlist = (subscription_id) => async dispatch  => {
        dispatch({
            type: 'setLoaderstatus', payload: true
        })
        
        var input_data = {
          "payment_method_key": payment_method_key,
          "channel": "Website",
          "payment_method_id":rstatus,
          "subscription_id": subscription_id,
        }
        const response = await saveSubscription(input_data);
        if (response.data.status == "success") {
    
          if (response.data.payment_status == 'pending') {
            const options = {
              key: response.data.data.razorpayKey, // Enter the Key ID generated from the Dashboard
              amount: response.data.data.total_amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
              currency: "INR",
              name: "Apna shopee",
              description: "Test Transaction",
              order_id: response.data.data.razorpayOrderId,
              image: "data:image/png;base64,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",
    
              // order_id: "order_9A33XWu170gUtm", //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
              handler: function (responsech) {
                const checkout_data = {
                  "razorpay_order_id": responsech.razorpay_order_id,
                  "razorpay_payment_id": responsech.razorpay_payment_id,
                  "razorpay_signature": responsech.razorpay_signature,
                  "order_id": response.data.data.orderid,
                  "payment_method_key": payment_method_key,
                  "payment_method_id": rstatus,
                  "subscription_id": subscription_id
                }
                updateCheckout(checkout_data)
              },
    
              "modal": {
                "ondismiss": function () {
                  window.location.replace("/checkout");
                }
              },
              config: {
                display: {
                  blocks: {
                    banks: {
                      name: 'All payment methods',
                      instruments: [
                        {
                          method: 'upi'
                        },
                        {
                          method: 'card'
                        },
                        {
                          method: 'netbanking'
                        }
                      ],
                    },
                  },
                  sequence: ['block.banks'],
                  preferences: {
                    show_default_blocks: false,
                  },
                },
              },
           
              theme: {
                color: "#ff9933",
              },
            };
            const rzp1 = new Razorpay(options);
            rzp1.on("payment.failed", function (response) {
              
            });
    
            rzp1.open();
          }
        }
      };

    return { getProfileData, updateProfile, sendotp ,getSubscriptionlist,getSubscription,saveSubscriptionlist,saveSubscription,};
};

export default MyAccountAction;































// import React from "react"
// import Apis from "../services/Apis";
//  const MyAccountAction =()=>{

//     const { getUserProfile, updateCustomerProfile, sendotpService, verifyotpService } = Apis();

//     return{

//     }
//  }
//  export default MyAccountAction;